import { IonItem, IonItemDivider, IonItemGroup, IonLabel } from '@ionic/react';
import { Trans } from '@lingui/macro';
import React from 'react';

import { IJobList } from '../../interfaces/IJob';
import JobItem from './JobItem';

interface JobListsProps {
    viewingPastJobs: boolean;
    groupedJobs: { [p: string]: IJobList[] };
}

const List: React.FC<JobListsProps> = ({ viewingPastJobs, groupedJobs }) => {
    return (
        <>
            {Object.keys(groupedJobs).length ? (
                Object.keys(groupedJobs).map((key) => {
                    const jobsGroupdByDate = groupedJobs[key];
                    return (
                        <IonItemGroup key={key}>
                            <IonItemDivider
                                color={
                                    viewingPastJobs ? 'secondary' : 'primary'
                                }
                            >
                                <IonLabel>{key}</IonLabel>
                            </IonItemDivider>
                            {jobsGroupdByDate.map((job) => (
                                <JobItem
                                    key={job.id}
                                    job={job}
                                    viewingPastJobs={viewingPastJobs}
                                />
                            ))}
                        </IonItemGroup>
                    );
                })
            ) : (
                <IonItem lines="none">
                    <h4>
                        <Trans>No installations available!</Trans>
                    </h4>
                </IonItem>
            )}
        </>
    );
};

export default List;
